export const testimonials = [
  {
    id: 1,
    name: '小明同学',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20casual%20style%2C%20warm%20lighting%2C%20professional%20headshot%2C%20clean%20cream%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    title: '资源太全了！',
    content: '找了好久的一部冷门漫画，居然在虫虫漫画上找到了！更新也很快，现在已经成了我的追漫首选平台。',
  },
  {
    id: 2,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20teenager%20portrait%20avatar%2C%20friendly%20smile%2C%20warm%20natural%20lighting%2C%20professional%20headshot%2C%20clean%20beige%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    title: '页面加载超快',
    content: '之前用的几个漫画网站加载都很慢，虫虫漫画的阅读体验真的没话说，翻页流畅，画质清晰，推荐给所有漫友！',
  },
  {
    id: 3,
    name: '追漫小仙女',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20soft%20lighting%2C%20professional%20headshot%2C%20clean%20light%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 5,
    title: '界面简洁好看',
    content: '特别喜欢虫虫漫画的界面设计，简洁大方又不失美感。分类也很清晰，找漫画特别方便。每天必刷！',
  },
  {
    id: 4,
    name: '老二次元了',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20man%20portrait%20avatar%2C%20casual%20confident%20look%2C%20warm%20lighting%2C%20professional%20headshot%2C%20clean%20cream%20background&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    title: '国漫之光',
    content: '看了十几年漫画，虫虫漫画的国产漫画资源是最全的。支持国漫，支持虫虫漫画！希望越做越好。',
  },
  {
    id: 5,
    name: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20cute%20style%2C%20soft%20warm%20lighting%2C%20professional%20headshot%2C%20clean%20beige%20background&width=100&height=100&seq=avatar-05&orientation=squarish',
    rating: 4,
    title: '每天睡前必看',
    content: '每天晚上躺在床上刷刷虫虫漫画已经成了习惯，更新及时，种类多，总能找到喜欢的作品。',
  },
  {
    id: 6,
    name: '江湖夜雨',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20avatar%2C%20mature%20professional%20look%2C%20warm%20natural%20lighting%2C%20professional%20headshot%2C%20clean%20light%20background&width=100&height=100&seq=avatar-06&orientation=squarish',
    rating: 5,
    title: '武侠迷的天堂',
    content: '作为一个武侠迷，虫虫漫画上的武侠分类简直是我的快乐源泉。镖人、秦时明月，每一部都是精品。',
  },
];